'use client';

import { requestOTPAction } from '@/app/api/server-actions/otp';
import { OTPCodeInput } from '@/components/login/OTPCodeInput';
import { OTPEmailRequest } from '@/components/login/OTPEmailRequest';
import { ROUTES } from '@/configs/routes';
import { useRouter } from '@/i18n/navigation';
import { Button } from '@venienergygroup/shared-components';
import { ArrowLeft } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

type OTPStep = 'request' | 'validate';

const OTPFlow = () => {
  const router = useRouter();
  const [step, setStep] = useState<OTPStep>('request');
  const [email, setEmail] = useState('');
  const t = useTranslations('LoginPage');

  const handleEmailSubmitted = (submittedEmail: string) => {
    void requestOTPAction(submittedEmail);
    setEmail(submittedEmail);
    setStep('validate');
  };

  const handleBackToEmail = () => {
    setEmail('');
    setStep('request');
  };

  const handleBack = () => {
    router.push(ROUTES.LOGIN);
  };

  return (
    <div className="w-full space-y-4">
      <div className="w-full">
        {step === 'request' ? (
          <div className="flex flex-col gap-y-2">
            <OTPEmailRequest onEmailSubmitted={handleEmailSubmitted} />
            <Button variant="ghost" onClick={handleBack}>
              <ArrowLeft /> {t('otp.code.backButton')}
            </Button>
          </div>
        ) : (
          <OTPCodeInput email={email} onBackClick={handleBackToEmail} redirectUrl={ROUTES.HOME} />
        )}
      </div>
    </div>
  );
};

export default OTPFlow;
